<template>
    <section class="module-small bg-dark ctaImg" id="cta1">
          <div class="container" style="width:-webkit-fill-available;">
            <div class="row">
              <div class="col-xs-12">
                <div data-aos="fade-right">
                  <h3 class="cta-title" id="signup">Sign up for our newsletter!</h3>
                   <!--
                  <div data-mailtrain-subscription-widget data-url="https://mail.halfhumangames.com/subscription/rJfit7pAM/widget">
                    <form id="subscription-form" role="form" method="post">
                    <div class="input-group " data-aos="fade-left">
                      <input class="form-control" type="email" id="semail" name="semail" placeholder="Your Email" data-validation-required-message="Please enter your email address." required="required"/><span class="input-group-btn">
                        <a href="https://mail.halfhumangames.com/subscription/rJfit7pAM" class="btn btn-g btn-round cta-subtitle1" style="background-color: #33adff" id="subscription-form-submit" type="submit">Subscribe</a></span>
                    </div>
                  </form>
                  </div> -->
                  <div id="mc_embed_signup">
                  <form action="https://halfhumangames.us20.list-manage.com/subscribe/post?u=0137a8236f6ae6db0a6cc9b2b&amp;id=e0b4502ce9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                      <div id="mc_embed_signup_scroll">
                      
                  <div class="mc-field-group">
                      <label for="mce-EMAIL">Email Address </label>
                      <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
                  </div>
                      <div id="mce-responses" class="clear">
                          <div class="response" id="mce-error-response" style="display:none"></div>
                          <div class="response" id="mce-success-response" style="display:none"></div>
                      </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_0137a8236f6ae6db0a6cc9b2b_e0b4502ce9" tabindex="-1" value=""></div>
                      <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
                      </div>
                  </form>
                  </div>
                  <p class="cta-subtitle">You will be entered for a chance <br> to win alpha access!</p>
              </div>
            </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  methods: {
    mailtrainStyling() {
      var mailForm = document.getElementsByClassName(
        "mailtrain-subscription-widget"
      );
      var h3 = mailForm[0];
      h3.innerHTML = h3.innerHTML.replace(
        "Newsletter",
        "Sign up for our newsletter!"
      );
      h3.className += " cta-title";
    }
  },
  mounted() {

    delete window.mailtrain;
    let mailtrain = document.createElement("script");
    mailtrain.async = true;

    mailtrain.setAttribute(
      "src",
      "https://mail.halfhumangames.com/subscription/widget.js"
    );
    document.head.appendChild(mailtrain);
    // mailtrain.onload = (function() {
    //   this.mailtrainStyling();
    // })();
    // this.$nextTick(function() {
    //   this.mailtrainStyling();
    // });
  }
};
</script>

<style>
@import "https://fonts.googleapis.com/css?family=Rubik+One";
.button::before,
.button::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.aos-init.aos-animate {
    z-index: 0;
}


@font-face {
  font-family: Digitalt;
  font-display: swap;
  src: url(/static/assets/lib/Digitalt.otf);
}
.cta-title {
  font-family: Digitalt;
  font-size: 30px;
     width: 100%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  color: #ffb03d;
  background: linear-gradient(
    to right,
    rgb(255, 181, 63) 0%,
    rgb(255, 255, 255) 15%,
    rgb(255, 255, 255) 29%,
    rgb(255, 255, 255) 75%,
    rgb(255, 255, 255) 77%,
    rgb(255, 177, 61) 100%
  );
}

.ctaImg {
  background: url(/static/assets/images/Yellow-Texture.png);
}

.module-small {
  padding: 95px 0;
}
.cta-subtitle1 {
  font-family: Digitalt;
  font-size: 23px;
  height: 48px;
  color: white;
}
.cta-subtitle {
  font-family: Digitalt;
  font-size: 23px;
  text-shadow: 1px 1px 1px rgb(82, 82, 82);
  padding-top: 0px;
  line-height: 100%;
}

.overlay:before {
  position: absolute;
  content: " ";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 0;
  background-color: rgba(31, 12, 30, 0.45);
}

.btn {
  padding: 6.5px 32px;
}
.form-control {
  height: 48px;
}
.module-small {
  padding: 24px 0;
  text-align: center;
  margin-top: 0px;
  overflow: hidden;
  padding-bottom: 24px;
  border-bottom: 9px double #0f0a06;
  border-top: 9px double #0f0a06;
}
.emphasized {
  font-size: 22px;
  display: inline-block;
  color: #3498dd00;
  text-shadow: -2.4px -2.4px 0 #3498dd, -2.4px -0.4px 0 #0a0d0e,
    -1.4px -2.4px 0 #04060a;
}
form.form {
    width: 100%;
    max-width: 816px;
    margin-right: auto;
    margin-left: auto;
}
.col-xs-12 {
  padding-left: 0;
  padding-right: 0;
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 10px;
    padding-right: 10px;
  }
}
/* @media only screen and (max-width: 1274px) {
  .col-xs-12 {
    padding-left: 25%;
    padding-right: 25%;
  }
} */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .emphasized {
    font-size: 25px;
  }
  .cta-subtitle {
    font-size: 25px;
  }
  .cta-title {
    font-size: 20px;
  }
  .btn {
    padding: 8.5px 10px;
  }
}

@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  .form-control {
    height: 39px;
  }
  .btn {
    padding: 8.5px 8px;
  }
  .cta-subtitle1 {
    font-size: 14px;
    height: 39px;
  }
  .cta-subtitle {
    font-size: 12px;
  }
  .cta-title {
    font-size: 18px;
  }
  .emphasized {
    font-size: 12px;
  }
  .callout-btn-box {
    margin-top: -29px !important;
  }
}
/* Mailtrain styles */
.form-group.email label {
  display: none;
}
.form-group {
  display: inline-block;
  margin-right: -6px;
  width: 64%;
}
form.form button {
    background-color: #33adff;
    font-size: 24px;
    height: 53px;
    position: relative;
    right: 0;
    z-index: 0;
    margin-bottom: 4.6px;
    display: inline-block;
    padding-right: 10px !important;
    padding-left: 19px !IMPORTANT;
    padding: 0;
    border: unset;
    word-spacing: 30px;
    width: 142px;
    overflow: hidden;
    color: #fff;
    font-family: Digitalt;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
}
.form-group.email input {
  font-family: Roboto Condensed,sans-serif;
    display: inherit;
    padding: 0 5px;
    color: #000;
    font-size: 16px;
    height: 53px;
    border: 1px solid #eaeaea;
    position: relative;
    z-index: 0;
    width: 100%;
    left: 0;
    margin-bottom: 0;
    border-radius: 0;
    transition: all .4s ease-in-out 0s;
}
.form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
.mailtrain-subscription-widget h3 {
  display: none;
}
h3.cta-title {
  display: block;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  form.form button {
    font-size: 19px;
  }
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  form.form button {
    font-size: 19px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  form.form button {
    height: 39px;
  }
  .form-group.email input {
    height: 39px;
  }
}
/* @media only screen and (min-device-width: 300px) and (max-device-width: 768px) {
  form.form {
    width: 100%;
    max-width: 600px;
}
} */
</style>


// WEBPACK FOOTER //
// src/views/Home/CTA1.vue